module.exports = __webpack_public_path__ + "media/images/emblems/Burtigny-coat_of_arms-f7b3217522f26ef1b352b086d923ad43.svg";